import React from 'react';
import { useNavigate } from 'react-router-dom';
const RedeemVoucher: React.FC = () => {
  const navigate = useNavigate();
  return (
    <button
      className="pointer flex h-[220px] w-[468px] flex-col items-center justify-center gap-[10px] rounded-3xl bg-white shadow-custom xl:h-[278px]"
      onClick={() => navigate('/redeem-voucher')}
    >
      <svg
        width="61"
        height="53"
        viewBox="0 0 61 53"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.00683594"
          width="60.9863"
          height="53"
          fill="url(#pattern0_2665_2333)"
          fill-opacity="0.7"
        />
        <defs>
          <pattern
            id="pattern0_2665_2333"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use transform="scale(0.00142857 0.00164384)" />
          </pattern>
        </defs>
      </svg>

      <div className="text-center text-lg font-medium leading-[27px]">
        Redeem Voucher
      </div>
    </button>
  );
};
export default RedeemVoucher;
